import { Badge, Table, Group, ActionIcon, rem, Loader, Text } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import { db } from '../../firebase-config';
import { doc, deleteDoc } from 'firebase/firestore';
import { CopyableId } from '../copyableId/CopyableId';

export function TestUsersTable({ data, filter, loading, error }) {
    const [tableData, setTableData] = useState(data);


    // Sync tableData with incoming data prop if it changes
    useEffect(() => {
        let filtered = data;
        if (filter && filter !== 'All') {
            filtered = data.filter((item) => (item.brands).find((brand) => brand.id === filter));
        }
        filtered = filtered.map((item) => ({ ...item, actions: false }));
        setTableData(filtered);
    }, [data, filter]);

    if (loading) {
        return <Loader />;
    }

    const handleDelete = async (id) => {
        setTableData((prev) => prev.filter((item) => item.id !== id));
        try {
            await deleteDoc(doc(db, 'config', 'testUsers', 'users', id));
        } catch (err) {
            console.error('Failed to delete user from Firestore:', err);
        }
    };

    const rows = tableData.map((item, index) => (
        <Table.Tr key={index} style={{ cursor: 'pointer' }} onClick={() => {}}>
            <Table.Td>
                <Group gap="xs" wrap="nowrap">
                    <Text fz="sm">{item.id}</Text>
                    <CopyableId id={item.id} label="Test user ID" />
                </Group>
            </Table.Td>
            <Table.Td>
                <Badge variant="dark" size='lg'>
                    {item.code}
                </Badge>
            </Table.Td>
            <Table.Td>
                {item.personName ? (
                    <Group gap="xs" wrap="nowrap">
                        <Text fz="sm" fw={500}>{item.personName}</Text>
                        {item.personType && (
                            <Badge variant="light" color={item.personType === 'Staff' ? 'yellow' : 'blue'}>
                                {item.personType}
                            </Badge>
                        )}
                    </Group>
                ) : (
                    <Text fz="sm" c="dimmed">No user</Text>
                )}
            </Table.Td>
            <Table.Td>
                <Group gap={0} justify="flex-end">
                    <ActionIcon variant="subtle" color="red" onClick={(e) => { e.stopPropagation(); handleDelete(item.id); }}>
                        <IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </ActionIcon>
                </Group>
            </Table.Td>
        </Table.Tr>
    ));

    return (
        <>
            <Table.ScrollContainer minWidth={800}>
                <Table verticalSpacing="sm">
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>ID</Table.Th>
                            <Table.Th>Code</Table.Th>
                            <Table.Th>Person</Table.Th>
                            <Table.Th>Actions</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            </Table.ScrollContainer>
        </>
    );
}
